import React from 'react';
import { motion } from 'framer-motion';
import { Settings, Feather, Shield, Briefcase } from 'lucide-react';
const details = [{
  icon: Settings,
  title: 'Adjustable Inflation',
  desc: 'Control the exact amount of stretch you need.'
}, {
  icon: Feather,
  title: 'Soft Ergonomic Design',
  desc: "Plush velvet material won't chafe or irritate skin."
}, {
  icon: Shield,
  title: 'Durable Materials',
  desc: 'Built to last with high-quality air valves and seams.'
}, {
  icon: Briefcase,
  title: 'Lightweight & Travel-Friendly',
  desc: 'Deflates flat to easily fit in any bag or suitcase.'
}];
export function ProductDetails() {
  return <section className="bg-white py-16 lg:py-24 px-4 sm:px-6 lg:px-8" data-id="element-113">
      <div className="max-w-7xl mx-auto" data-id="element-114">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-115">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full lg:w-1/2" data-id="element-116">
            <img src="https://cdn.magicpatterns.com/uploads/rEX3XFSdcNBN3jGrbyKC8X/producto_zen.png" alt="Product Details" className="w-full max-w-md mx-auto rounded-2xl shadow-lg bg-brand-gray-light" data-id="element-117" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full lg:w-1/2" data-id="element-118">
            <h2 className="text-3xl sm:text-4xl font-bold text-brand-black mb-10 text-center lg:text-left" data-id="element-119">
              Premium Quality Design
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-120">
              {details.map((detail, index) => {
              const Icon = detail.icon;
              return <div key={index} className="flex gap-4" data-id="element-121">
                    <div className="mt-1" data-id="element-122">
                      <Icon className="w-6 h-6 text-brand-purple" data-id="element-123" />
                    </div>
                    <div data-id="element-124">
                      <h3 className="text-lg font-bold text-brand-black mb-1" data-id="element-125">
                        {detail.title}
                      </h3>
                      <p className="text-brand-gray-dark text-sm leading-relaxed" data-id="element-126">
                        {detail.desc}
                      </p>
                    </div>
                  </div>;
            })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}